module.exports = __webpack_public_path__ + "img/ucloud.3c3c7326.png";